import { toGqlId } from "@src/api/formatters/shopify";
import {
  FetchProductPickerSelectedProductsDocument,
  FetchProductPickerSelectedProductsQuery,
  FetchProductPickerSelectedProductsQueryVariables,
} from "@src/generated";
import { shopifyGqlClient } from "@src/providers/gqlProvider";
import { executeChunked } from "@src/store/helpers";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export async function loadSelectedProducts(ids: string[]) {
  return executeChunked({
    data: ids,
    execute: loadChunk,
  });
}

async function loadChunk(ids: string[]) {
  const response = await shopifyGqlClient.query<
    FetchProductPickerSelectedProductsQuery,
    FetchProductPickerSelectedProductsQueryVariables
  >({
    query: FetchProductPickerSelectedProductsDocument,
    variables: { ids: ids.map((id) => toGqlId(id, "Product")) },
    fetchPolicy: "cache-first",
  });
  const products: ProductPickerSelectedProduct[] = [];
  for (const node of response.data.nodes) {
    if (node?.__typename === "Product") {
      products.push({
        id: node.id,
        title: node.title,
        image: node.featuredImage?.url as string | undefined,
        handle: node.handle,
        requiresSellingPlan: node.requiresSellingPlan,
      });
    }
  }
  return products;
}
